import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <DeleteDewarDialog dewar onDeleteDewarClick = {item} onCancelClick = {} />
 */

class DeleteDewarDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Удалить сосуд Дьюара
			</DialogTitle>

			<DialogContent>
				Вы уверены, что ходите удалить сосуд Дьюара?
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteDewarClick === "function") {
							this.props.onDeleteDewarClick(this.props.dewar)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default DeleteDewarDialog